import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import Breadcrumb from "../../components/BreadCumbsLinks";
import UseGeneral from "../../hooks/useGeneral";
import Left from "./Left";
import { Right } from "./Right";
import "./style.css";
import CryptoJS from "crypto-js";
import moment from "moment";
import { useDispatch } from "react-redux";
import { emptyCart } from "../../store/offlineCartReducer/OfflineCartReducer";
import { Loader } from "rsuite";
import axios from "axios";
import PopUp from "../../components/popup";
import AddLocation from "../Profile/location/AddLocation";
const PayDetils = () => {
  const dispatch = useDispatch();
  let localCart = localStorage.getItem("local_cart");
  let cartArr = localCart && JSON.parse(localCart);
  const [openAddLocation, setOpenAddLocation] = useState(false);
  const [walletPartValue, setWalletPartValue] = useState(0);
  const [openSetWalletValue, setOpenSetWalletValue] = useState(false);
  const localData = localStorage.getItem("discount_coupon");
  const decryptedBytes = localData && CryptoJS.AES.decrypt(localData, "111");
  const discount =
    decryptedBytes && JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));

  let cartDataTotalPrice = 0;
  if (cartArr && cartArr.length) {
    for (let k = 0; k < cartArr.length; k++) {
      cartDataTotalPrice += cartArr[k].price * 1 * cartArr[k].quantity;
      if (
        cartArr[k].product_optionsarr &&
        cartArr[k].product_optionsarr.length > 0
      ) {
        let options = [...cartArr[k].product_optionsarr];
        for (let y = 0; y < options.length; y++) {
          //
          cartDataTotalPrice += options[y].price * 1 + options[y].quantity * 1;
        }
      }
    }
  }
  const { language } = UseGeneral();
  const navigate = useNavigate();
  const breadCrumbsLinks = [
    { name: language != "ar" ? "Home" : "الصفحة الرئيسية", path: "/" },
    {
      name: language != "ar" ? "Cart" : "العربة",
      path: "/Cart",
    },
    {
      name: language != "ar" ? "Complete Order" : "استكمال الطلب",
      active: true,
    },
  ];
  const [meData, setMeData] = useState({});
  const [pageLoading, setPageLoading] = useState(false);
  const [cardInfo, setCardInfo] = useState({
    cvv: "",
    end_date: "",
    card_number: "",
    user_card_name: "",
  });
  const [order_time, setorder_time] = useState("");
  const [userLoading, setUserLoading] = useState(false);
  const [userOrderInfo, setUserOrderInfo] = useState({
    name: "",
    phone: "",
    location: "",
  });
  const [addLoading, setAddLoading] = useState(false);
  const [pay_type, setpay_type] = useState("cash_on_delivery");
  const [choose_subs, setchoose_subs] = useState("");
  const [locations, setLocations] = useState([]);
  const [activeLocation, setActiveLocation] = useState("");
  const [delivary_type, setdelivary_type] = useState("");
  const [showCancOrder, setShowCancOrder] = useState(true);
  const [userData, setUserData] = useState();
  const [walletValue, setWalletValue] = useState(0);

  const [walletData, setWalletData] = useState({});

  const getMyWalletValue = () => {
    // const token=local

    let greenLocalData = localStorage.getItem("greenTreesUserData");
    let greenData = greenLocalData && JSON.parse(greenLocalData);
    //
    if (greenData) {
      axios
        .get(BASE_URL + `user_wallets/get_one_wallet/${greenData?.id}`)
        .then((res) => {
          if (res.data.status == "success") {
            setWalletValue(res.data.result.money_value);
          }
          //
        })
        .catch((e) => console.log(e));
    }
  };

  const searchOfflineWallet = () => {
    const offlineUserData = JSON.parse(localStorage.getItem("userPayInfo"));
    const GreenTreesToken = localStorage.getItem("GreenTreesToken");
    if (!GreenTreesToken && offlineUserData) {
      axios
        .post(BASE_URL + `user_wallets/search_my_wallet`, {
          phone: offlineUserData?.userphone,
        })
        .then((res) => {
          if (res.data.status == "success") {
            setWalletData(res.data.result);
          }
          //
        })
        .catch((e) => console.log(e));
    }
  };

  const handleConfirm = () => {
    if (delivary_type != "quickly" && order_time == "") {
      toast.error(
        language == "ar"
          ? "إختر وقت إذا لم تريد التوصيل سريعا"
          : "Select Date If You If You Do not Need Quickly delivary"
      );
      return;
    }
    if (
      pay_type == "cash" &&
      (cardInfo.card_number == "" ||
        cardInfo.cvv == "" ||
        cardInfo.user_card_name == "" ||
        cardInfo.end_date == "")
    ) {
      toast.error(
        language == "ar"
          ? "أدخل بيانات الدفع إذا كنت تريد الدفع بالبطاقه"
          : "Enter Card Data If You need to pay with Card"
      );
      return;
    }
    if (activeLocation == "") {
      toast.error(language == "ar" ? "أدخل مكان" : "Enter Location");
      return;
    }
    setAddLoading(true);
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    let order_value = 0;
    const formattedDate = `${year}-${month}-${day}`;
    // return formattedDate;
    let prodsText = "";
    let cartList = [...cartArr];
    let productsoptions = "";
    for (let i = 0; i < cartList.length; i++) {
      if (cartList[i].product_options != "") {
        // let optionList=[...]
        //
        if (productsoptions == "") {
          productsoptions += cartList[i].product_options;
        } else {
          productsoptions += "***green***" + cartList[i].product_options;
        }
        // setAddLoading(false)
        // return
      }
      if (i == 0) {
        prodsText +=
          cartList[i].id +
          "*green*" +
          cartList[i].quantity +
          "*green*" +
          cartList[i].weight;
      } else {
        prodsText +=
          "**green**" +
          cartList[i].id +
          "*green*" +
          cartList[i].quantity +
          "*green*" +
          cartList[i].weight;
      }
      if (cartList[i]?.discount * 1 > 0) {
        order_value +=
          (cartList[i].price * 1 - cartList[i].discount * 1) *
          cartList[i].quantity;
      } else {
        order_value += cartList[i].price * 1 * cartList[i].quantity;
      }
    }

    if (pay_type == "wallet") {
      const localWallet_data_send = {
        phone: userOrderInfo.phone,
        wallet_phone: userOrderInfo.phone,
        customer_phone: userOrderInfo.phone,
        customer_name: userOrderInfo.name,
        delivary_type: order_time != "" ? "time" : "quickly",
        order_time: delivary_type == "quickly" ? formattedDate : order_time,
        location: activeLocation,
        pay_type: "wallet",
        choose_subs,
        cvv: cardInfo.cvv,
        end_date: cardInfo.end_date,
        card_number: cardInfo.card_number,
        user_card_name: cardInfo.user_card_name,
        has_options: productsoptions != "" ? 1 : 0,
        prods: prodsText,
        product_options: productsoptions,
        delivaery: localStorage.getItem("GreenTreesToken")
          ? selectedLocations?.region_data?.price
          : localStorage.getItem("offlineUserAddress")
          ? JSON.parse(localStorage.getItem("offlineUserAddress"))?.region_price
          : "",
        discount: discount ? discount?.discount?.val : 0,
        discount_type:
          discount?.discount?.type == "percentage" ? "percentage" : "flat",
        order_value: order_value,
        product_options: productsoptions,
      };
      // if (discount) {
      //   localWallet_data_send["order_value"] =
      //     localWallet_data_send["order_value"] * 1 - (discount?.discount?.type == 'percentage' ? (discount?.discount?.val / 100) *  localWallet_data_send["order_value"] : discount?.discount?.val );
      // }

      // if (+walletData.balance < +localWallet_data_send.order_value) {
      //   setAddLoading((prev) => false);
      //   toast.error(
      //     language == "ar"
      //       ? "ليس لديك رصيد كافي في المحفظة"
      //       : "You don't have enough money in your wallet"
      //   );
      //   return;
      // };
      Axios({
        url: BASE_URL + "orders/make_order_by_local_wallet",
        method: "POST",
        data: localWallet_data_send,
        language: language,
      })
        .then((res) => {
          if (res.status == "success") {
            setShowCancOrder(true);
            getMeData();
            localStorage.removeItem("discount_coupon");
            dispatch(emptyCart());
            navigate("/success", {
              replace: true,
              state: { order: res.result },
            });
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        })
        .finally(() => {
          setAddLoading(false);
        });
    } else {
      const data_send = {
        phone: userOrderInfo.phone,
        delivary_type: order_time != "" ? "time" : "quickly",
        order_time: delivary_type == "quickly" ? formattedDate : order_time,
        location: activeLocation,
        pay_type,
        choose_subs,
        cvv: cardInfo.cvv,
        end_date: cardInfo.end_date,
        card_number: cardInfo.card_number,
        user_card_name: cardInfo.user_card_name,
        has_options: productsoptions != "" ? 1 : 0,
        prods: prodsText,
        delivaery: localStorage.getItem("GreenTreesToken")
          ? selectedLocations?.region_data?.price
          : localStorage.getItem("offlineUserAddress")
          ? JSON.parse(localStorage.getItem("offlineUserAddress"))?.region_price
          : "",
        customer_phone: userOrderInfo.phone,
        wallet_phone: userOrderInfo.phone,
        customer_name: userOrderInfo.name,
        discount: discount ? discount?.discount?.val : 0,
        discount_type:
          discount?.discount?.type == "percentage" ? "percentage" : "flat",
        order_value: order_value,
        product_options: productsoptions,
      };
      // if (discount) {
      //   data_send["order_value"] =
      //   data_send["order_value"] * 1 - (discount?.discount?.type == 'percentage' ? (discount?.discount?.val / 100) *  data_send["order_value"] : discount?.discount?.val );
      // }
      // setAddLoading(false)

      Axios({
        url: BASE_URL + "orders/make_order_by_local",
        method: "POST",
        data: data_send,
        language: language,
      })
        .then((res) => {
          if (res.message == "Sission Ended Login Again") {
            toast.error(res.message);
          } else if (res.message == "Login First") {
            toast.error(res.message);
          }

          if (res.status == "success") {
            setShowCancOrder(true);
            getMeData();
            localStorage.removeItem("discount_coupon");
            dispatch(emptyCart());
            navigate("/success", {
              replace: true,
              state: { order: res.result },
            });
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        })
        .finally(() => {
          setAddLoading(false);
        });
    }
  };

  const payWithWallet = () => {
    if (delivary_type != "quickly" && order_time == "") {
      toast.error(
        language == "ar"
          ? "إختر وقت إذا لم تريد التوصيل سريعا"
          : "Select Date If You If You Do not Need Quickly delivary"
      );
      return;
    }
    if (
      pay_type == "cash" &&
      (cardInfo.card_number == "" ||
        cardInfo.cvv == "" ||
        cardInfo.user_card_name == "" ||
        cardInfo.end_date == "")
    ) {
      toast.error(
        language == "ar"
          ? "أدخل بيانات الدفع إذا كنت تريد الدفع بالبطاقه"
          : "Enter Card Data If You need to pay with Card"
      );
      return;
    }
    if (activeLocation == "") {
      toast.error(language == "ar" ? "أدخل مكان" : "Enter Location");
      return;
    }
    setAddLoading(true);
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    let order_value = 0;
    const formattedDate = `${year}-${month}-${day}`;
    // return formattedDate;
    let prodsText = "";
    let cartList = [...cartArr];
    let productsoptions = "";
    for (let i = 0; i < cartList.length; i++) {
      if (cartList[i].product_options != "") {
        // let optionList=[...]
        //
        if (productsoptions == "") {
          productsoptions += cartList[i].product_options;
        } else {
          productsoptions += "***green***" + cartList[i].product_options;
        }
        // setAddLoading(false)
        // return
      }
      if (i == 0) {
        prodsText +=
          cartList[i].id +
          "*green*" +
          cartList[i].quantity +
          "*green*" +
          cartList[i].weight;
      } else {
        prodsText +=
          "**green**" +
          cartList[i].id +
          "*green*" +
          cartList[i].quantity +
          "*green*" +
          cartList[i].weight;
      }
      if (cartList[i]?.discount * 1 > 0) {
        order_value +=
          (cartList[i].price * 1 - cartList[i].discount * 1) *
          cartList[i].quantity;
      } else {
        order_value += cartList[i].price * 1 * cartList[i].quantity;
      }
    }

    const data_send = {
      phone: userOrderInfo.phone,
      delivary_type: order_time != "" ? "time" : "quickly",
      order_time: delivary_type == "quickly" ? formattedDate : order_time,
      location: activeLocation,
      pay_type,
      choose_subs,
      cvv: cardInfo.cvv,
      end_date: cardInfo.end_date,
      card_number: cardInfo.card_number,
      user_card_name: cardInfo.user_card_name,
      has_options: productsoptions != "" ? 1 : 0,
      prods: prodsText,
      product_options: productsoptions,
      order_value: order_value,
      discount: discount?.discount?.val,
      discount_type: discount?.discount?.type,
    };
    // if (discount) {
    //   data_send["order_value"] =
    //     data_send["order_value"] * 1 -
    //     (discount?.discount?.type == "percentage"
    //       ? (discount?.discount?.val / 100) * data_send["order_value"]
    //       : discount?.discount?.val);
    // }
    // setAddLoading(false)
    // return
    Axios({
      url: BASE_URL + "orders/make_order_by_local",
      method: "POST",
      data: data_send,
      language: language,
    }).then((res) => {
      if (res.message == "Sission Ended Login Again") {
        // toast.error(res.message);
      }
      if (res.status == "success") {
        const data_send2 = {
          type: "dec",
          value: data_send["order_value"],
        };
        let greenLocalData = localStorage.getItem("greenTreesUserData");
        let greenData = greenLocalData && JSON.parse(greenLocalData);
        axios
          .post(
            BASE_URL + `user_wallets/change_money_to_wallet/${greenData?.id}`,
            data_send2
          )
          .then((res2) => {
            if (res2.data.status == "success") {
              getMyWalletValue();
              setShowCancOrder(true);
              getMeData();
              localStorage.removeItem("discount_coupon");
              dispatch(emptyCart());
              navigate("/success", {
                replace: true,
                state: { order: res.result },
              });
              toast.success(res.message);
            }
          })
          .catch((e) => console.log(e))
          .finally(() => {
            setAddLoading(false);
          });
      }
    });
  };

  const partialPayWithWallet = () => {
    if (delivary_type != "quickly" && order_time == "") {
      toast.error(
        language == "ar"
          ? "إختر وقت إذا لم تريد التوصيل سريعا"
          : "Select Date If You If You Do not Need Quickly delivary"
      );
      return;
    }
    if (
      pay_type == "cash" &&
      (cardInfo.card_number == "" ||
        cardInfo.cvv == "" ||
        cardInfo.user_card_name == "" ||
        cardInfo.end_date == "")
    ) {
      toast.error(
        language == "ar"
          ? "أدخل بيانات الدفع إذا كنت تريد الدفع بالبطاقه"
          : "Enter Card Data If You need to pay with Card"
      );
      return;
    }
    if (activeLocation == "") {
      toast.error(language == "ar" ? "أدخل مكان" : "Enter Location");
      return;
    }
    setAddLoading(true);
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    let order_value = 0;
    const formattedDate = `${year}-${month}-${day}`;
    // return formattedDate;
    let prodsText = "";
    let cartList = [...cartArr];
    let productsoptions = "";
    for (let i = 0; i < cartList.length; i++) {
      if (cartList[i].product_options != "") {
        // let optionList=[...]
        //
        if (productsoptions == "") {
          productsoptions += cartList[i].product_options;
        } else {
          productsoptions += "***green***" + cartList[i].product_options;
        }
        // setAddLoading(false)
        // return
      }
      if (i == 0) {
        prodsText +=
          cartList[i].id +
          "*green*" +
          cartList[i].quantity +
          "*green*" +
          cartList[i].weight;
      } else {
        prodsText +=
          "**green**" +
          cartList[i].id +
          "*green*" +
          cartList[i].quantity +
          "*green*" +
          cartList[i].weight;
      }
      if (cartList[i]?.discount * 1 > 0) {
        order_value +=
          (cartList[i].price * 1 - cartList[i].discount * 1) *
          cartList[i].quantity;
      } else {
        order_value += cartList[i].price * 1 * cartList[i].quantity;
      }
    }

    const data_send = {
      phone: userOrderInfo.phone,
      wallet_phone: userOrderInfo.phone,
      delivary_type: order_time != "" ? "time" : "quickly",
      order_time: delivary_type == "quickly" ? formattedDate : order_time,
      location: activeLocation,
      pay_type,
      choose_subs,
      cvv: cardInfo.cvv,
      end_date: cardInfo.end_date,
      card_number: cardInfo.card_number,
      user_card_name: cardInfo.user_card_name,
      has_options: productsoptions != "" ? 1 : 0,
      prods: prodsText,
      wallet_value: parseFloat(walletValue),
      cash_value:
        (meData?.location?.region_data?.price
          ? meData?.location?.region_data?.price + order_value
          : order_value) - walletValue,
      product_options: productsoptions,
      order_value: order_value,
      discount: discount?.discount?.val,
      discount_type: discount?.discount?.type,
    };
    // if (discount) {
    //   data_send["order_value"] =
    //     data_send["order_value"] * 1 -
    //     (discount?.discount?.type == "percentage"
    //       ? (discount?.discount?.val / 100) * data_send["order_value"]
    //       : discount?.discount?.val);
    // }
    // setAddLoading(false)
    // return
    Axios({
      url: BASE_URL + "orders/make_order_by_local_cash_and_wallet",
      method: "POST",
      data: data_send,
      language: language,
    })
      .then((res) => {
        if (res.status == "success") {
          getMyWalletValue();
          setShowCancOrder(true);
          getMeData();
          localStorage.removeItem("discount_coupon");
          dispatch(emptyCart());
          navigate("/success", {
            replace: true,
            state: { order: res.result },
          });
          setOpenSetWalletValue(false);
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
      })
      .finally(() => {
        setAddLoading(false);
      });
  };

  const [selectedLocations, setSelectedLocations] = useState(null);
  const [offlineUserAddress, setOfflineUserAddress] = useState({});

  const getOfflineUserAddress = () => {
    const offLineAddressData =
      JSON.parse(localStorage.getItem("offlineUserAddress")) || {};
    setOfflineUserAddress(offLineAddressData);
  };

  const getMeData = () => {
    setUserLoading((prev) => true);

    Axios({
      url: BASE_URL + "user/me",
      method: "POST",
    })
      .then((res) => {
        if (res.message == "Sission Ended Login Again") {
          // toast.error(res.message);
        }
        if (res.status == "success") {
          // alert("sad");
          if (res.result.location == null) {
            setOpenAddLocation(true);
            // navigate("/profile", { replace: true });
          }
          setMeData(res.result);
          setUserOrderInfo({
            name: res.result.name,
            phone: res.result.phone,
            location: res.result.location,
          });
          // setCartTotalPrice(res.result.cart_total_price*1-res.result.money_minus*1);
        }
      })
      .finally(() => {
        setPageLoading(false);
        setUserLoading((prev) => false);
        if (
          !localStorage.getItem("GreenTreesToken") &&
          localStorage.getItem("userPayInfo")
        ) {
          const userPayInfoData = JSON.parse(
            localStorage.getItem("userPayInfo")
          );
          const offlineUserAddress = localStorage.getItem("offlineUserAddress");

          setUserOrderInfo((prev) => ({
            ...prev,
            name: userPayInfoData.username,
            phone: userPayInfoData.userphone,
            location: offlineUserAddress,
          }));
        }
      })
      .catch((e) => {});
  };

  const getUserLocations = () => {
    setUserLoading((prev) => true);
    Axios({
      url: BASE_URL + "userlocation/get_user_locations",
      method: "GET",
    })
      .then((res) => {
        if (res.message == "Sission Ended Login Again") {
          // toast.error(language == "ar" ? "من فضلك سجل" : "Login Please");
        }

        if (res.status == "success") {
          if (Array.isArray(res.result)) {
            setLocations(res.result);
            let userLocations = [...res.result];
            setActiveLocation(
              userLocations?.filter((item) => (item.status = 1))[0].id
            );
            setSelectedLocations(
              userLocations?.filter((item) => (item.status = 1))[0]
            );
          }
          // setLocations();
        }
      })
      .finally(() => {
        setUserLoading((prev) => false);
      })
      .catch((e) => {});

    if (
      localStorage.getItem("offlineUserAddress") &&
      !localStorage.getItem("GreenTreesToken")
    ) {
      setActiveLocation((prev) =>
        JSON.parse(localStorage.getItem("offlineUserAddress"))
      );
    }
  };

  const [enterAddressModal, setEnterAddressModal] = useState(false);
  const [enteredAddess, setEnteredAddress] = useState("");
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedDis, setSelectedDis] = useState("");
  const [districts, setDistricts] = useState([]);

  const [newLoc, setNewLoc] = useState({
    name: "",
    phone: "",
    city: "",
    streat: "",
    architecture: "",
    floor: "",
    apartment: "",
    special_marque: "",
    location: "",
    status: 0,
    district: "",
    region: "",
  });

  const [offlineUser, setOfflineUser] = useState({
    username: "",
    userphone: "",
  });

  useEffect(() => {
    const userDataOffline = JSON.parse(localStorage.getItem("userPayInfo"));

    setOfflineUser({
      ...userDataOffline,
    });

    const offlineUserAddressData = JSON.parse(
      localStorage.getItem("offlineUserAddress")
    );

    if (offlineUserAddressData) {
      setNewLoc((prev) => ({
        ...prev,
        ...offlineUserAddressData,
      }));
    }
  }, []);

  const getRegionDist = () => {
    const data_send = {
      region_id: selectedRegion,
    };
    Axios({
      url: BASE_URL + "districts/get_all_for_user",
      method: "POST",
      data: data_send,
    })
      .then((res) => {
        if (res.message == "Sission Ended Login Again") {
          // toast.error(res.message);
        }
        if (res.status == "success") {
          setDistricts(res.result);
          setSelectedDis(res.result[0].id);
        }
      })
      .catch((e) => {})
      .finally(() => {
        setAddLoading(false);
      });
  };

  const getRegions = () => {
    Axios({
      url: BASE_URL + "regions/get_all_for_user",
      method: "GET",
    })
      .then((res) => {
        if (res.message == "Sission Ended Login Again") {
          // toast.error(res.message);
        }
        if (res.status == "success") {
          setRegions(res.result);
          // setSelectedRegion(res.result[0].id);
          setNewLoc((prev) => ({ ...prev, region: res.result[0].id }));
        }
      })
      .catch((e) => {})
      .finally(() => {
        setAddLoading(false);
      });
  };

  useEffect(() => {
    searchOfflineWallet();
    setUserLoading((prev) => true);
    getMyWalletValue();
    getMeData();
    getUserLocations();
    getRegions();
    getRegionDist();
    getOfflineUserAddress();
  }, []);

  // useEffect(() => {
  //   if (!localStorage.getItem("GreenTreesToken")) {
  //     toast.error(
  //       language == "ar" ? "يرجى تسجيل الدخول أولا" : "Please log in first"
  //     );
  //     navigate("/login", { replace: true });
  //   }
  // }, []);

  useEffect(() => {
    if (
      !localStorage.getItem("GreenTreesToken") &&
      !localStorage.getItem("offlineUserAddress")
    ) {
      setEnterAddressModal(true);
    } else {
    }
  }, []);

  const rejestAddress = () => {
    const rejon_price = regions?.filter(
      (item) => +item.id == +newLoc?.region
    )[0]?.price;
    const rejon_name_ar = regions?.filter(
      (item) => +item.id == +newLoc?.region
    )[0]?.title_ar;
    const rejon_name_en = regions?.filter(
      (item) => +item.id == +newLoc?.region
    )[0]?.title_en;

    localStorage.setItem(
      "offlineUserAddress",
      JSON.stringify({
        region: newLoc?.region,
        region_ar: rejon_name_ar,
        region_en: rejon_name_en,
        region_price: rejon_price,
        city: newLoc?.city,
        district: newLoc?.district,
        streat: newLoc?.streat,
        architecture: newLoc?.architecture,
        floor: newLoc?.floor,
        apartment: newLoc?.apartment,
        special_marque: newLoc?.special_marque,
        location: newLoc?.location,
      })
    );

    localStorage.setItem(
      "userPayInfo",
      JSON.stringify({
        username: offlineUser.username,
        userphone: offlineUser.userphone,
      })
    );

    setEnterAddressModal(false);
    getMeData();
    getUserLocations();
    getOfflineUserAddress();
  };

  return (
    <div className="pay-details-container">
      <Breadcrumb links={breadCrumbsLinks} />
      <div className="main-content">
        <>
          {" "}
          {userLoading ? (
            <div className="right-container">
              <Loader size="lg" />
            </div>
          ) : (
            <Right
              setOpenSetWalletValue={setOpenSetWalletValue}
              setWalletValue={setWalletValue}
              payType={pay_type}
              locations={locations}
              setpay_type={setpay_type}
              setorder_time={setorder_time}
              setdelivary_type={setdelivary_type}
              delivary_type={delivary_type}
              setActiveLocation={setActiveLocation}
              activeLocation={activeLocation}
              setSelectedLocations={setSelectedLocations}
              choose_subs={choose_subs}
              setchoose_subs={setchoose_subs}
              cardInfo={cardInfo}
              setCardInfo={setCardInfo}
              userOrderInfo={userOrderInfo}
              setUserOrderInfo={setUserOrderInfo}
              userLoading={userLoading}
              enterAddressModal={enterAddressModal}
              setEnterAddressModal={setEnterAddressModal}
            />
          )}
        </>
        <Left
          walletValue={walletValue}
          selectedLocations={selectedLocations}
          addLoading={addLoading}
          payWithWallet={payWithWallet}
          partialPayWithWallet={partialPayWithWallet}
          handleConfirm={
            pay_type == "wallet_and_cash"
              ? () => setOpenSetWalletValue(true)
              : handleConfirm
          }
          handlePay={handleConfirm}
          payType={pay_type}
          locations={locations}
          offlineUserAddress={offlineUserAddress}
        />
      </div>

      <PopUp
        open={enterAddressModal}
        title={language == "ar" ? "ادخل العنوان" : "Rejesteration for payment"}
        setOpen={() => {
          setEnterAddressModal(false);
        }}
        children={
          <div className="add-location-container">
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                return rejestAddress();
              }}
              className="d-flex flex-column gap-3"
            >
              <div className="input-form">
                <label htmlFor="">
                  {language == "ar" ? "الاسم " : "Your Name"}
                </label>
                <input
                  type="text"
                  name="name"
                  value={offlineUser.username}
                  onChange={(e) => {
                    setOfflineUser({
                      ...offlineUser,
                      username: e.target.value,
                    });
                  }}
                />
              </div>

              <div className="input-form">
                <label htmlFor="">
                  {language == "ar" ? " رقم الموبايل" : "Phone Number"}
                </label>
                <input
                  type="text"
                  name="phone"
                  value={offlineUser.userphone}
                  onChange={(e) => {
                    setOfflineUser({
                      ...offlineUser,
                      userphone: e.target.value,
                    });
                  }}
                />
              </div>

              <div
                className="input-form"
                style={{ flexWrap: "wrap", width: "100% " }}
              >
                <label htmlFor="region">
                  {language == "ar" ? "الإمارة" : "Emirate"}
                  <span className="star">*</span>
                </label>
                <select
                  required
                  style={{ flexWrap: "wrap", width: "100% " }}
                  name="region"
                  id="region"
                  placeholder="اختر"
                  value={newLoc?.region}
                  defaultValue={newLoc?.region}
                  onChange={(e) => {
                    setNewLoc({ ...newLoc, region: e.target.value });
                  }}
                  // value={selectedRegion}
                >
                  {regions.map((item, index) => {
                    return (
                      <option value={+item.id}>
                        {language == "ar" ? item.title_ar : item.title_en}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="row4" style={{ flexWrap: "wrap" }}>
                <div className="input-form">
                  <label htmlFor="">
                    {language == "ar" ? "المنطقة" : "Region"}
                  </label>
                  <input
                    type="text"
                    value={newLoc.city}
                    name="city"
                    onChange={(e) => {
                      setNewLoc({ ...newLoc, city: e.target.value });
                    }}
                  />
                </div>

                <div className="input-form">
                  <label htmlFor="district">
                    {language == "ar" ? "الحي" : "District"}
                  </label>
                  <input
                    type="text"
                    value={newLoc?.district}
                    onChange={(e) => {
                      setNewLoc({ ...newLoc, district: e.target.value });
                    }}
                  />
                </div>
              </div>

              <div className="input-form">
                <label htmlFor="streat">
                  {language == "ar" ? "الشارع" : "The Street"}
                </label>
                <input
                  type="text"
                  placeholder=""
                  name="streat"
                  value={newLoc.streat}
                  onChange={(e) => {
                    setNewLoc({ ...newLoc, streat: e.target.value });
                  }}
                />
              </div>

              <div className="row6" style={{ flexWrap: "wrap" }}>
                <div className="input-form">
                  <label htmlFor="architecture">
                    {language == "ar" ? "العماره" : "The Building"}
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    name="architecture"
                    value={newLoc?.architecture}
                    onChange={(e) => {
                      setNewLoc({ ...newLoc, architecture: e.target.value });
                    }}
                  />
                </div>
                <div className="input-form">
                  <label htmlFor="floor">
                    {language == "ar" ? "دور" : "Floor"}
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    name="floor"
                    value={newLoc.floor}
                    onChange={(e) => {
                      setNewLoc({ ...newLoc, floor: e.target.value });
                    }}
                  />
                </div>
                <div className="input-form">
                  <label htmlFor="apartment">
                    {language == "ar" ? "شقة " : "Appartment"}
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    name="apartment"
                    value={newLoc?.apartment}
                    onChange={(e) => {
                      setNewLoc({ ...newLoc, apartment: e.target.value });
                    }}
                  />
                </div>
              </div>

              <div className="input-form">
                <label htmlFor="special_marque">
                  {language == "ar" ? "علامه مميزه" : "Land Mark"}
                </label>
                <input
                  type="text"
                  placeholder={
                    language == "ar"
                      ? "مثال: بجانب مكان ما"
                      : "Example: next to place"
                  }
                  name="special_marque"
                  value={newLoc?.special_marque}
                  onChange={(e) => {
                    setNewLoc({ ...newLoc, special_marque: e.target.value });
                  }}
                />
              </div>

              <div className="input-form">
                <label htmlFor="location">
                  {" "}
                  {language == "ar" ? "اسم العنوان " : "Address name"}{" "}
                </label>
                <input
                  type="text"
                  placeholder={
                    language == "ar"
                      ? "مثال: منزل, عمل..."
                      : "Example: home, work..."
                  }
                  name="location"
                  value={newLoc.location}
                  onChange={(e) => {
                    setNewLoc({ ...newLoc, location: e.target.value });
                  }}
                />
              </div>

              <button className="payment-rejestration-button">
                {language == "ar" ? "تأكيد" : "Confirm"}
              </button>
            </form>
          </div>
        }
      />
      <PopUp
        open={openSetWalletValue}
        title={
          language == "ar"
            ? "إضافة القيمة المراد دفعها بالمحفظة"
            : "Add the amount you want to pay to the wallet"
        }
        setOpen={setOpenSetWalletValue}
      >
        <div className="add-location-container">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="row4">
              <div className="input-form">
                <input
                  type="text"
                  onChange={(e) => setWalletValue(e.target.value)}
                  value={walletValue}
                />
              </div>
            </div>
          </form>
        </div>
        {!addLoading ? (
          <button
            style={{ marginTop: "20px" }}
            className="btn btn-success"
            onClick={() => setOpenSetWalletValue(false)}
          >
            {language == "ar" ? "دفع" : "Pay"}
          </button>
        ) : null}
      </PopUp>
      <PopUp
        open={openAddLocation}
        title={language == "ar" ? "إضافة عنوان " : "Add Address"}
        setOpen={setOpenAddLocation}
      >
        <AddLocation
          setOpenAddLocation={setOpenAddLocation}
          getAgainData={getUserLocations}
          first={true}
        />
      </PopUp>
    </div>
  );
};

export default PayDetils;
